import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { api } from '../../utils/api';

const Card = ({ label, value, color }) => (
  <div style={{background:'#fff',borderRadius:12,padding:'20px 24px',boxShadow:'0 1px 4px rgba(0,0,0,.06)',borderTop:`3px solid ${color}`}}>
    <div style={{fontSize:11,color:'#9095A8',fontWeight:600,textTransform:'uppercase',letterSpacing:'.08em'}}>{label}</div>
    <div style={{fontSize:28,fontWeight:700,color:'#0B0E1A',marginTop:6}}>{value}</div>
  </div>
);

export default function FornecedoresDashboard() {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/fornecedores/dashboard', token)
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div style={{padding:32,color:'#6B7289',fontSize:13}}>Carregando...</div>;

  const t = data?.totais || {};

  return (
    <div style={{padding:32,maxWidth:960,margin:'0 auto'}}>
      <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:28}}>
        <div>
          <h1 style={{fontSize:20,fontWeight:700,color:'#0B0E1A',margin:0}}>Base de Fornecedores</h1>
          <p style={{fontSize:13,color:'#9095A8',margin:'4px 0 0'}}>Visão geral da sua base de fornecedores internacionais.</p>
        </div>
        <button onClick={() => navigate('/mentor/fornecedores/lista')}
          style={{background:'#1A2ECC',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontSize:13,fontWeight:600,cursor:'pointer'}}>
          Ver todos os fornecedores
        </button>
      </div>

      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:16,marginBottom:32}}>
        <Card label="Total" value={t.total || 0} color="#1A2ECC" />
        <Card label="Aprovados" value={t.aprovados || 0} color="#0FA36B" />
        <Card label="Pendentes" value={t.pendentes || 0} color="#F59E0B" />
        <Card label="Não verificados" value={t.nao_verificados || 0} color="#9095A8" />
      </div>

      <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:20}}>
        {/* Por nicho */}
        <div style={{background:'#fff',borderRadius:12,padding:20,boxShadow:'0 1px 4px rgba(0,0,0,.06)'}}>
          <div style={{fontSize:12,fontWeight:700,color:'#0B0E1A',marginBottom:14,textTransform:'uppercase',letterSpacing:'.06em'}}>Por nicho</div>
          {data?.por_nicho?.length === 0 && <div style={{fontSize:12,color:'#9095A8'}}>Nenhum registro</div>}
          {data?.por_nicho?.map(n => (
            <div key={n.segmento} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'6px 0',borderBottom:'1px solid #F4F5F9'}}>
              <span style={{fontSize:13,color:'#3D4461'}}>{n.segmento}</span>
              <span style={{fontSize:12,fontWeight:700,color:'#1A2ECC',background:'#EEF1FF',borderRadius:99,padding:'2px 10px'}}>{n.total}</span>
            </div>
          ))}
        </div>

        {/* Por localização */}
        <div style={{background:'#fff',borderRadius:12,padding:20,boxShadow:'0 1px 4px rgba(0,0,0,.06)'}}>
          <div style={{fontSize:12,fontWeight:700,color:'#0B0E1A',marginBottom:14,textTransform:'uppercase',letterSpacing:'.06em'}}>Por localização</div>
          {data?.por_cidade?.length === 0 && <div style={{fontSize:12,color:'#9095A8'}}>Nenhum registro</div>}
          {data?.por_cidade?.map(c => (
            <div key={`${c.cidade}-${c.pais}`} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'6px 0',borderBottom:'1px solid #F4F5F9'}}>
              <span style={{fontSize:13,color:'#3D4461'}}>{c.pais} · {c.cidade}</span>
              <span style={{fontSize:12,fontWeight:700,color:'#1A2ECC',background:'#EEF1FF',borderRadius:99,padding:'2px 10px'}}>{c.total}</span>
            </div>
          ))}
        </div>

        {/* Por status */}
        <div style={{background:'#fff',borderRadius:12,padding:20,boxShadow:'0 1px 4px rgba(0,0,0,.06)'}}>
          <div style={{fontSize:12,fontWeight:700,color:'#0B0E1A',marginBottom:14,textTransform:'uppercase',letterSpacing:'.06em'}}>Por status</div>
          {data?.por_status?.map(s => {
            const colors = { aprovado:'#0FA36B', pendente:'#F59E0B', nao_verificado:'#9095A8' };
            const labels = { aprovado:'Aprovado', pendente:'Pendente', nao_verificado:'Não verificado' };
            return (
              <div key={s.status} style={{display:'flex',justifyContent:'space-between',alignItems:'center',padding:'6px 0',borderBottom:'1px solid #F4F5F9'}}>
                <span style={{fontSize:13,color:'#3D4461'}}>{labels[s.status] || s.status}</span>
                <span style={{fontSize:12,fontWeight:700,color:'#fff',background:colors[s.status]||'#9095A8',borderRadius:99,padding:'2px 10px'}}>{s.total}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{marginTop:24,display:'flex',gap:12}}>
        <button onClick={() => navigate('/mentor/fornecedores/lista')}
          style={{background:'#fff',color:'#1A2ECC',border:'1px solid #1A2ECC',borderRadius:8,padding:'10px 20px',fontSize:13,fontWeight:600,cursor:'pointer'}}>
          Ver lista completa
        </button>
        <button onClick={() => navigate('/mentor/fornecedores/importar')}
          style={{background:'#fff',color:'#3D4461',border:'1px solid #E2E4ED',borderRadius:8,padding:'10px 20px',fontSize:13,fontWeight:600,cursor:'pointer'}}>
          Importar / Exportar
        </button>
      </div>
    </div>
  );
}
